export function extract(bytes) {
  const data = new Uint8Array(bytes)
  const decoder = new TextDecoder('utf-8')
  const text = bytes => decoder.decode(bytes).split('\0')[0].trim()
  const files = []
  let offset = 0
  while (offset < data.length) {
    if (data.length - offset < 512) throw new Error('truncated TAR header')
    const header = data.subarray(offset, offset + 512)
    if (header.every(byte => byte === 0)) {
      if (data.subarray(offset).some(byte => byte !== 0)) throw new Error('data after TAR end marker')
      break
    }
    const sizeField = text(header.subarray(124, 136))
    if (!/^[0-7]+$/.test(sizeField)) throw new Error('invalid TAR entry size')
    const size = parseInt(sizeField, 8)
    const padded = Math.ceil(size / 512) * 512
    if (!Number.isSafeInteger(size) || !Number.isSafeInteger(padded) || padded > data.length - offset - 512) {
      throw new Error('truncated or oversized TAR entry')
    }
    const name = text(header.subarray(0, 100))
    const prefix = text(header.subarray(345, 500))
    const fullName = prefix ? prefix + '/' + name : name
    const type = header[156]
    if ((type === 0 || type === 48) && !fullName.endsWith('/')) {
      const content = data.slice(offset + 512, offset + 512 + size)
      files.push({ name: fullName, content: decoder.decode(content), blob: new Blob([content]) })
    }
    offset += 512 + padded
  }
  return files
}
